<template>
  <section class="cs-header">
    <div class="cs-header__close py-2">
      <div class="d-flex align-items-center">
        <div class="cs-header__left">
          <template v-if="marketInfo.merchant && marketInfo.merchant.shopData">
            <img
              v-if="
                marketInfo &&
                marketInfo.merchant &&
                marketInfo.merchant.shopData &&
                marketInfo.merchant.shopData.logo
              "
              class="cs-header__shop-icon"
              :class="{
                'cs-header__shop-icon_sky-tours':
                  marketInfo.merchant.shopData.companyName === 'Sky-tours',
              }"
              :src="marketInfo.merchant.shopData.logo"
              alt="logo"
            />
            <div
              id="shop-name"
              v-if="marketInfo.merchant.shopData.companyName !== 'Sky-tours'"
              class="cs-header__shop-name"
            >
              {{ marketInfo.merchant.shopData.companyName }}
            </div>
            <b-tooltip target="shop-name" triggers="hover" placement="top">
              {{ marketInfo.merchant.shopData.companyName }}
            </b-tooltip>
          </template>
        </div>
        <div class="d-flex ml-1">
          <div
            class="cs-header__tip"
            title="Support"
          >
            <a
              href="https://rocketfuelblockchain.zendesk.com/hc/en-us/requests/new"
              target="_blank"
            >
              <img
                width="90%"
                src="@/assets/img/support.svg"
                alt="tip"
                class="cs-header__tip__icon"
              />
            </a>
          </div>
          <div class="ml-1" v-if="cryptoWalletStep !== 2">
            <router-link
              v-if="$route.meta.settings"
              class="cs-header__settings"
              :to="{ name: 'Settings' }"
              @click="handleSettingEvent"
            >
              <img
                src="@/assets/img/settings.svg"
                alt="settings"
                class="cs-header__icon"
              />
            </router-link>
          </div>
          <div class="cs-header__tip ml-1" v-if="cryptoWalletStep !== 2">
            <img
              id="tip"
              width="80%"
              src="@/assets/img/questionMark.svg"
              alt="tip"
              class="cs-header__tip__icon"
            />
            <b-tooltip
              target="tip"
              class="tip"
              triggers="hover"
              placement="top"
            >
              {{ changePartnerLabelName(marketInfo, "sign-up.tipMessage") }}
            </b-tooltip>
          </div>
        </div>
      </div>
    </div>

    <PopupModal
      id="2"
      :title="$t('closing-modal.title')"
      :showModal="isIframeClosed"
      :description="
        $t('closing-modal.description') + $t('closing-modal.description2')
      "
      :cancel="$t('closing-modal.cancel')"
      :dismiss="$t('closing-modal.dismiss')"
      @cancelClicked="isIframeClosed = false"
      @dismissClicked="closeIFrame"
    />
  </section>
</template>

<script>
import { mapGetters } from "vuex";
import PopupModal from "@/components/PopupModal.vue";
import {
  GET_MARKET_INFO,
  USER_TRACK_EVENTS,
} from "@/store/modules/user/consts";
import { routeEnum } from "../store/modules/auth/enum";

// import MultiDropdown from '@/components/MultiDropdown.vue';

export default {
  name: "BankComponent",
  mounted() {
    // this.$refs.loader.end();
    this.$nextTick(async () => {
      // this.$refs.loader.start();
      if (Object.values(this.cart).length) {
        await this.getData();
        // this.$refs.loader.end();
      } else {
        window.EventBus.emit("ADD_INFO_MESSAGE", {
          message: "waiting cart...",
        });
      }
    });
    window.EventBus.on("is-preview", (val) => {
      this.isPreview = val;
    });
    window.EventBus.on("PopupClosed", (popup) => {
      this.PopupClosed = popup;
    });
  },
  components: {
    // MultiDropdown,
    PopupModal,
  },
  data() {
    return {
      isIframeClosed: false,
      isPreview: "",
      PopupClosed: null,
    };
  },
  watch: {
    async cart() {
      if (Object.values(this.cart).length) {
        window.EventBus.emit("DELETE_INFO_MESSAGE", {
          message: "waiting cart...",
        });
        await this.getData();
        // this.$refs.loader.end();
      }
    },
  },
  computed: {
    ...mapGetters({
      cart: "user/cart",
      tab: "user/tab",
      marketInfo: "user/marketInfo",
      paymentCompleted: "auth/paymentCompleted",
      cryptoWalletStep: "user/getCryptoWalletStep",
    }),
  },
  methods: {
    triggerCloseModel() {
      if (!this.isPreview && this.tab === "Crypto Wallet") {
        this.isIframeClosed = true;
      } else {
        this.closeIFrame();
      }
    },
    async getData() {
      const request = [
        this.$store.dispatch(`user/${GET_MARKET_INFO}`, {
          merchantId: this.cart.merchant_id,
        }),
      ];
      await Promise.all(request);
    },
    async closeIFrame() {
      // to handle the NestedIframe issue ACI
      await this.$store.dispatch(`user/${USER_TRACK_EVENTS}`, {
        moduleInfo: {
          current: "Header",
          activity: "iframe closed",
        },
      });
      this.notifyParentWindow({
        type: "rocketfuel_iframe_close",
        paymentCompleted: this.paymentCompleted,
      });
    },
    async handleSettingEvent() {
      this.$store.dispatch(`user/${USER_TRACK_EVENTS}`, {
        moduleInfo: {
          current: "Payment Page",
          activity: "clicked on setting button",
        },
      });
    },
    isWelcomePage() {
      return this.$route.name === routeEnum.WELCOME;
    },
  },
};
</script>

<style lang="scss" scoped>
@keyframes rotate {
  100% {
    transform: rotate(360deg);
  }
}

.cs-header {
  padding: 0 10px;
  z-index: 0;
  min-height: 50px;
  // display: flex;
  // flex-flow: row;
  // justify-content: space-between;
  // align-items: center;
  // gap: 10px;
  top: 0;
  left: 0;
  background-color: $white;
  /*
  display: flex;
  align-items: center;
  justify-content: space-between;
  */
  transition: 0.3s;
  &_scrolled {
    box-shadow: 0px 3px 5px rgba(32, 42, 68, 0.12);
  }
  &__row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0px 0px;
    &__icon {
      border: none;
      margin: 0;
    }
  }
  &__left,
  &__right {
    display: flex;
    align-items: center;
  }

  &__left {
    // max-width: 230px;
    width: 100%;
    display: flex;
    align-items: center;
  }

  &__right {
    justify-content: flex-end;
  }

  &__logo {
    width: 28px;
    min-width: 28px;
    object-fit: contain;
    margin-right: 14px;
  }

  &__shop-icon {
    height: 50px;
    margin-right: 10px;
    // margin-bottom: 5px;
    // TODO это временное решение имеено для sky-tours
    &_sky-tours {
      width: 135px;
      object-fit: cover;
    }
  }

  &__shop-name {
    font-size: 22px;
    line-height: 21px;
    font-weight: 600;
    min-width: 75px;
    max-width: 150px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    cursor: pointer;
  }

  &__title {
    width: 159px;
    min-width: 159px;
    object-fit: contain;
  }

  &__btn {
    @include gradient-box;
    background-color: $white;
    width: 25px;
    min-width: 25px;
    height: 25px;
    object-fit: contain;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: 0.3s;
    border: none;
    z-index: 9999999999;
    & img {
      width: 18px;
    }
    &:hover {
      background-color: $gradient-grey;
    }
  }

  &__settings {
    @include gradient-box;
    background-color: $white;
    border: none;
    width: 25px;
    min-width: 20px;
    height: 25px;
    object-fit: contain;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: 0.3s;
    border-radius: 50%;
    img {
      padding: 2px;
    }
    &:hover {
      background-color: $gradient-grey;
      & img {
        animation: rotate 1.25s linear infinite;
      }
    }
  }

  &__login {
    @include gradient-box;
    background-color: $white;
    width: 90px;
    min-width: 90px;
    height: 30px;
    object-fit: contain;
    margin-right: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    line-height: 23px;
    transition: 0.3s;
    &:hover {
      background-color: $gradient-grey;
    }
    & img {
      width: 14px;
      margin-right: 7px;
    }
  }
  &__close {
    /* display: flex; */
    justify-content: space-between;
    align-items: center;
  }
  &__tip {
    // @include gradient-box;
    // border: 1px solid #1D1D3F;
    // background-color: $white;
    width: 25px;
    min-width: 20px;
    height: 25px;
    object-fit: contain;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: 0.3s;
    // border-radius: 50%;
    // padding: 2px;
    margin-left: 8px;
    &__icon {
      height: 100%;
      width: 20px;
      cursor: pointer;
      // border-radius: 50%;
    }
  }
}

.close-modal {
  &__title {
    font-size: 17px;
  }

  &__desc {
    background: rgba(0, 0, 0, 0.05);
    padding: 10px;
    font-size: 13px;
  }

  &__footer-btn {
    padding: 0px 10px;
    cursor: pointer;
    border-radius: 5px;
    color: #5559fe;
    margin: 0px 5px;
    border: 1px solid #5559fe;
  }

  &__footer-btn:nth-child(2) {
    background: #5559fe;
    color: white;
  }

  &__info-img {
    margin-top: -75px;
    margin-right: 10px;
  }

  &__action-btns {
    display: block;
    margin: auto;
  }
}

::v-deep(.modal-header) {
  border: none !important;
  padding: 0px 5px;
}

::v-deep(.modal-footer) {
  border: none !important;
  padding-bottom: 20px;
}

::v-deep(.modal) {
  padding: 0px !important;
}
</style>
